import { useState, useEffect } from 'react';
import { AdminETLTask } from '../types';
import { adminETLService } from '../services/admin-etl.service';

export const useAdminETLTasks = () => {
  const [tasks, setTasks] = useState<AdminETLTask[]>([]);
  const [statistics, setStatistics] = useState<any>(null);
  const [workersStatus, setWorkersStatus] = useState<any>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const loadTasks = async () => {
    try {
      setIsLoading(true);
      setError(null);
      
      const [tasksData, stats, workers] = await Promise.all([
        adminETLService.getAllTasks(),
        adminETLService.getTaskStatistics(),
        adminETLService.getWorkersStatus(),
      ]);

      setTasks(tasksData);
      setStatistics(stats);
      setWorkersStatus(workers);
    } catch (err: any) {
      setError(err.message || 'Failed to load ETL tasks');
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    loadTasks();
  }, []);

  return {
    tasks,
    statistics,
    workersStatus,
    isLoading,
    error,
    refetch: loadTasks,
  };
};

